angular.module('zc.zenclerkS')

  .component('zcsDashboardWidgetTest', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.html',
    require: {
      dashboard: '^zcsDashboardMain'
    },
    controller: zcsDashboardWidgetTestController
  });

zcsDashboardWidgetTestController.$inject = [];
function zcsDashboardWidgetTestController() {
  const vm = this;

  vm.$onInit = () => {
    vm.project = vm.dashboard.project;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.component.js